import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export function Refresh(props) {
    const [, setState] = React.useState(new Date().toISOString());
    function tick() {
        setState(new Date().toISOString());
    }
    React.useEffect(() => {
        const timer = setInterval(() => tick(), props.afterMs);
        return () => {
            clearInterval(timer);
        };
    }, [props.afterMs]);
    if (!props.children) {
        return _jsx(_Fragment, {});
    }
    if (typeof props.children === 'function') {
        return _jsx(_Fragment, { children: props.children() });
    }
    else {
        return _jsx(_Fragment, { children: props.children });
    }
}
